import React from 'react'

import { Button } from './Button'

export function PromiseButton(props: { onClick: () => Promise<void> } & React.ComponentProps<typeof Button>) {
  const [loading, setLoading] = React.useState(false)

  async function handleClick() {
    setLoading(true)
    await props.onClick()
    setLoading(false)
  }

  return <Button {...props} onClick={handleClick} disabled={loading} spinner={loading} />
}
